export default "__VITE_ASSET__pUayaLCC5cXfH2SWbpDFQg__"